/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-filename-extension */
import React, { Component } from 'react';

import DiscussForm from './PickRequest';
import DatePicker from '../partials/DatePicker';

export default class RequestNow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        name:"",
        email:"",
        dateData: "20222, 06, 18, 0, 0",
        phone:"",
        rooms: 1,
        bathrooms:1,
        category: 'studio residence'
      },
    };
  }

//   getDataD = (obj) => {
//     console.log(this.obj)

//     dateData = obj;
// }

  componentDidMount() {
    window.scroll(0, 0);
  }

    onChange = (event) => {
      this.setState({
        data: {
          // eslint-disable-next-line react/no-access-state-in-setstate
          ...this.state.data,
          [event.target.name]: event.target.value,
        },
      });
    }

    resetForm = () => {
      this.setState({
        data: {
            name: "",
            email:"",
            dateData: "",
            phone:"",
            rooms: 1,
            bathrooms:1,
            category: 'studio residence'
        },
      });
    }

    render() {
      const { data } = this.state;

      return (
        <>
          {/* eslint-disable-next-line react/jsx-props-no-spreading */}
          <div  className='form' style={{ display: 'flex', justifyContent: 'center'}}>
                <h1>Request</h1>
                </div>
                <div  style={{ display: 'flex', justifyContent: 'center'}} className="pickRoom">
          <DiscussForm data={data} onChange={this.onChange} resetForm={this.resetForm} />
       </div>
       {/* <DatePicker  /> */}
        </>
      );
    }
}
